import { render, staticRenderFns } from "./kpi-flow-manager.vue?vue&type=template&id=2d264b7b"
import script from "./kpi-flow-manager.vue?vue&type=script&lang=js"
export * from "./kpi-flow-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports